import { createRoute, redirect } from '@tanstack/react-router';
import { locationSuffix } from '../../lib/guards';
import { HomeIndexRoute, lazyPage } from '../common';
import { siteRoute } from '../layouts';

const pages = () => import('./pages');
const activityComp = lazyPage(pages, 'ActivityHost');
const featuresComp = lazyPage(pages, 'FeaturesHost');

// Index of the site-env layout: the platform-chosen home page at /$siteId/$siteEnv.
export const teamOverviewRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: '/',
  component: HomeIndexRoute,
});

const activityRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'activity',
  component: activityComp,
  staticData: { title: 'site.activity' },
});

const featuresRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'features',
  component: featuresComp,
  staticData: { title: 'site.features' },
});

// Legacy Sales Agents URL - /$siteId/$siteEnv/sales-agents -> /$siteId/$siteEnv/customers/agents
const salesAgentsAliasRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'sales-agents',
  beforeLoad({ location }) {
    throw redirect({
      href: `${location.pathname.replace(/\/sales-agents\/?$/, '/customers/agents')}${locationSuffix(location)}`,
    });
  },
});

// Legacy Orders URL - /$siteId/$siteEnv/orders -> /$siteId/$siteEnv/activity
const ordersAliasRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'orders',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/$siteEnv/activity', params });
  },
});

// Legacy Discounts URL - /$siteId/$siteEnv/discounts -> /$siteId/$siteEnv/pricing/discounts
const discountsAliasRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'discounts',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/$siteEnv/pricing/discounts', params });
  },
});

// Anything under a site that isn't one of its pages. The session guards look the site up quietly
// (a mistyped url shouldn't raise an error toast) and `/` then lands the user on it - or back home
// when there is no such site.
const unknownSitePageRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: '$',
  staticData: { unknownSitePage: true },
  beforeLoad() {
    throw redirect({ to: '/' });
  },
});

/** Site-env home leaves: activity, features, sales-agents, the legacy aliases and the catch-all. */
export const siteLeaves = [
  activityRoute,
  featuresRoute,
  salesAgentsAliasRoute,
  ordersAliasRoute,
  discountsAliasRoute,
  unknownSitePageRoute,
];
